import __request__ from "routing/request";
export function update(config, requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.archive/config", config, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.archive/config", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function snapshotArchivingDefaults(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.archive/config/snapshot-archiving/defaults", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function snapshotArchivingTypes(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.archive/config/snapshot-archiving/types", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
